<div class="chatbot-container" [ngClass]="{ 'open': isOpen }">
  <mat-card class="chatbot-card">
    <mat-card-header >
  
       <img src="../../../../assets/images/bizdata-header-logo.svg" alt="logo" class="header-logo">
        <button mat-icon-button aria-label="Close" (click)="toggleCoPilot()"> <mat-icon>close</mat-icon>
        </button>
   
    </mat-card-header>
    <div class="chat-history" #chatHistory (scroll)="onScroll()">
      <div *ngFor="let message of messages; let i=index" 
           [ngClass]="{'user-message-container': message.author === 'user', 'bot-message-container': message.author === 'bot'}">
        <div class="message"
             [ngClass]="{'user-message': message.author === 'user', 'bot-message': message.author === 'bot'}">
          <div *ngIf="message.content == ''" class="message-content">
            <mat-spinner class="orange-spinner" *ngIf="message.author === 'bot' && message.content == ''" class="btn-spinner"
                         diameter="30"></mat-spinner>
          </div>

          <div clipboard [clipboardButtonComponent]="clipboardButton" markdown [data]="message.content" 
               id="bot_message_{{i}}" *ngIf="message.content != '' && message.author === 'bot'" class="variable-binding bot-message">
          </div>

          <div *ngIf="message.author == 'user'" class="user-message-content">
            {{message.content}}
          </div>
        </div>

        <div class="msg-info-user" *ngIf="message.content != '' && message.author == 'user'">
          <div class="msg-actions" *ngIf="message.author === 'user'">
          
          </div>
          <p class="timestamp">{{message.timeStamp}}</p>
        </div>
        <div class="msg-info-bot" *ngIf="message.content != '' && message.author == 'bot'">
          <div class="msg-actions" *ngIf="message.author === 'bot'">
          
          </div>
          <div class="msg-bot-sec">
            <p class="timestamp">{{message.timeStamp}}</p>
            <div>
              <mat-icon class="refresh" matTooltip="Regenerate" (click)="regenerateResponse(i)">
                autorenew
              </mat-icon>
              <mat-icon class="refresh" [matTooltip]="copyStr" (click)="copyResponse(i)">
                content_paste
              </mat-icon>
              <mat-icon matTooltip="Bad response" *ngIf="!sending" class="dislike"
              (click)="dislikeMessage(message.messageId, i)">
              {{ message.is_dislike == 1 ? 'thumb_down' : 'thumb_down_off_alt' }}
          </mat-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <mat-card-actions class="chat-input-container">
      <div class="input-wrapper">
        <textarea matInput #userInput placeholder="Type your message..." rows="1" class="chat-input-textarea" [(ngModel)]="editorMsg" (keydown.enter)="sendMessage($event)" [readonly]="sending"></textarea>
        <button mat-icon-button aria-label="Send" (click)="sendMessage(); userInput.value=''" >
          <mat-icon style="color: red;">send</mat-icon>
        </button>
      </div>
    </mat-card-actions>
   

  <div class="chat-footer">
    <div class="footer-content">
      <span>Powered by </span>
      <img src="../../../../assets/images/Goldfinch_new.png" alt="Goldfinch AI Agent" class="footer-logo">
      <span>Goldfinch AI Agent</span>
    </div>
  </div>
    </div>
</mat-card>
</div>

<ion-fab *ngIf="isAccess" vertical="bottom" horizontal="end" slot="fixed" style="bottom:30px !important;">
  <ion-fab-button (click)="toggleCoPilot()" title="chatbubble">
    <ion-icon name="chatbubble"></ion-icon>
  </ion-fab-button>
</ion-fab>
